// extracted by mini-css-extract-plugin
export default {"otpGroup":"OTPInput_otpGroup__kEkxE","otpInput":"OTPInput_otpInput__NuLcB","error":"OTPInput_error__QLLsN"};